import { render, staticRenderFns } from "./DocumentsPrintPage.vue?vue&type=template&id=2a74ab0a"
import script from "./DocumentsPrintPage.vue?vue&type=script&lang=js"
export * from "./DocumentsPrintPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports